module.exports = __webpack_public_path__ + "static/media/bannerbackground.02efadff.png";